export class ClientClaim {
    key: string;
    value: string;                    
}

export class ClientAllowedScope {
    id: number;
    value: string;
}

export class Client {
    accessTokenType: string;
    lastAccessed: Date;
    createdAt: Date;
    clientName: string;
    clientDescription: string;
    enabled: boolean;
    clientId: string;
    isBusy: boolean;
    isDeleted: boolean;
    clientClaims: ClientClaim[];
    allowedScopes: ClientAllowedScope[];
    clientType: string;
}

export class ClientsResponse {
    clients: Client[];
}

export class ClientResponse {
    client: Client;
}

export class ClientSecretResponse {
    secrets: ClientSecrect[];
}

export class ClientSecrect {
    id: number;
    description: string;
    expiration?: Date;
}

export class CreateClientSecretRequest {
    secret: string;
    clientId: string;
    description: string;
    expiresAt?: Date;
}